import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const WorkFlowStep = createAsyncThunk(
  "StepsWorkFlow/WorkFlowSteps",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "/api/WorkFlow/WorkFlowSteps",
        parameters
      );

      const data = response.data;
      console.log(data, "sssssssssdwdwd");
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const StepsWorkFlow = createSlice({
  name: "StepsWorkFlow",
  initialState: {
    workFlow: {},

    loadingWorkFlow: false,
    errorWorkFlow: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(WorkFlowStep.pending, (state, action) => {
        state.loadingWorkFlow = true;
        state.workFlow = action.payload;
        state.errorWorkFlow = null;
      })
      .addCase(WorkFlowStep.fulfilled, (state, action) => {
        state.loadingFlowSubmitter = false;
        state.workFlow = action.payload;
      })
      .addCase(WorkFlowStep.rejected, (state, action) => {
        state.loadingFlowSubmitter = false;
        state.workFlow = action.payload;
      });
  },
});
export default StepsWorkFlow.reducer;
